import { GETSTREAM_STATUS, GETSTREAM_SET_CLIENT } from '@/app/store/actions/getstream';

const initialState = {
	client: null,
    status: null,
};

const getstream = (state = initialState, action) => {
	switch (action.type) {
		case GETSTREAM_SET_CLIENT: {
			return {
				...state,
				client: action.client || null,
                status: action.client ? 'connected' : null,
			};
		}

        case GETSTREAM_STATUS: {
            return {
                ...state,
                status: action.status,
            }
        }

		default: {
			return state;
		}
	}
};

export default getstream;
